<template>
    <div> 
        <div class="row">
            <div class="col-sm-12">
                <div :id="`map-id-${id}`" style="height:400px;"></div>
            </div>
        </div>
    </div>
</template>
<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import icon from 'leaflet/dist/images/marker-icon.png';

export default {
    props: {
        coords: Object,
        id: Number,
        toleranceRadius: Number
    },
    mounted() {
        this.initializeMap(this.coords, this.id);
    },
    methods: {
        zoom(r){ 
            /*Calculates the necessary zoom as a function of the tolerance radius.
            Its motivation goes as follows: the zoom levels of Leaflet divide
            the quadrants into subsequent quadrants. So, for zoom=0 we have the original map,
            for zoom=1, it is divided in 4, for zoom=2 is 16=4^2 and it goes on.

            So, the area of the quadrant as a function of the zoom z is
            A(z)=(Pi^2*(6.5)^2*10^12)/4^(z-1)   m^2.

            The 6.5 factor comes from rounding the Earth's radius to 6.5*10^6 m.

            Hence, if we solve for the zoom we obtain (obviating the division by m^2), 
            z(A)=1+[2(ln Pi +ln 6.5 + 6ln 10)-ln A]/2ln 2.

            For further simplification, we consider that the tolerance radius R will define a circle 
            inscribed inside a square, whose area will be 4R^2. Furthermore, if
            this radius is given in kilometers, we can write R=r*1000, whereupon
            we find

            z(r)=4+3*ln 5/ln 2+ln(Pi*6.5/[2r])/ln 2.
            */
            return 4 + 3 * Math.log(5) / Math.log(2) + Math.log(Math.PI * 6.5 / (2 * r)) / Math.log(2);
        },
        initializeMap(coords, id) {

            const r =this.toleranceRadius/1000;

            const origin = this.validCoords(coords.location) 
                ? [coords.location.lat, coords.location.long] 
                : this.validCoords(coords.submitter) 
                ? [coords.submitter.lat, coords.submitter.long] 
                : this.validCoords(coords.signer) 
                ? [coords.signer.lat, coords.signer.long] :
                null;

            const map = L.map(`map-id-${id}`,{
                zoomSnap:0.25
            }).setView(origin, Math.floor(this.zoom(r)*10)/10);
            
            // Draw map
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: 'Map data © OpenStreetMap contributors',
                maxZoom: 20,
            }).addTo(map);

            // Initialise markers
            // Tolerance radius
            if(coords.location.lat && coords.location.long){
                L.circle([coords.location.lat, coords.location.long], { //Circle centred at ttevent coordinates
                color: 'red',
                fillColor: '#f03',
                fillOpacity: 0.4,
                radius: this.toleranceRadius
                }).addTo(map);
            }
           
            // submitterMarker
            if(coords.submitter.lat && coords.submitter.long){
                const submitterMarker = L.icon({ iconUrl: icon }); // This is provisional until we decide on an icon
                L.marker([coords.submitter.lat,coords.submitter.long],
                { icon: submitterMarker}).addTo(map);
            }

            //signerMarker
            if(coords.signer.lat && coords.signer.long){
                const signerMarker = L.icon({ iconUrl: icon }); // This is provisional until we decide on an icon
                L.marker([coords.signer.lat,coords.signer.long],
                { icon: signerMarker}).addTo(map);
            }
            

        },
        validCoords(obj) {
            return Object.values(obj).every(value => value !== undefined && value !== null && value !== '');
        }
    },
}
</script>
